import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../auth/authConfig';

const PAGE_BACKGROUND = {
  background: 'linear-gradient(135deg, #4B1D6B 0%, #6B2D8B 50%, #8B4DAB 100%)',
};

function Login() {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginRedirect(loginRequest);
  };

  return (
    <div className="flex min-h-screen items-center justify-center px-4" style={PAGE_BACKGROUND}>
      <div className="w-full max-w-sm text-center">
        <h1 className="mb-1 text-5xl font-bold text-white [text-shadow:2px_2px_4px_rgba(0,0,0,0.3)]">
          Nano
        </h1>
        <p className="mb-6 text-lg text-white/90">Nano Fibre UK Platform</p>

        <div className="rounded-lg bg-white/95 p-8 shadow-lg">
          <img
            src={`${process.env.PUBLIC_URL}/nano-fibre-logo.svg`}
            alt="Nano Fibre UK"
            className="mx-auto mb-4 h-10 w-auto"
          />
          <p className="mb-6 text-sm text-gray-500">Sign in with your company account</p>
          <button
            type="button"
            onClick={handleLogin}
            className="w-full rounded-md bg-brand px-4 py-2 text-sm font-medium text-white hover:bg-brand-dark"
          >
            Sign in with Microsoft
          </button>
        </div>
      </div>
    </div>
  );
}

export default Login;
